/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface SentenceEntity
 */
export interface SentenceEntity {
    /**
     * 
     * @type {number}
     * @memberof SentenceEntity
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SentenceEntity
     */
    text?: string;
}

/**
 * Check if a given object implements the SentenceEntity interface.
 */
export function instanceOfSentenceEntity(value: object): boolean {
    return true;
}

export function SentenceEntityFromJSON(json: any): SentenceEntity {
    return SentenceEntityFromJSONTyped(json, false);
}

export function SentenceEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SentenceEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function SentenceEntityToJSON(value?: SentenceEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'text': value['text'],
    };
}

